import axios, {AxiosRequestConfig} from 'axios';
import {getAppid, getEndpoints, getLocale, getToken} from '../store';
import { localStore } from '../store/useLocalStore';
import matchlog from "../utils/matchlog";
import axiosRetry from "axios-retry";

export const SUCCESS_CODE = 0;

export const isSuccess = (res: { code: number; message: string; data?: any }) => {
    return res.code === SUCCESS_CODE;
};

export interface MyResponseType<T> {
    code: number;
    data: T;
    message: string;
    success: boolean;
    fail: boolean;
    result: T;
}

const instance = axios.create({
    timeout: 60000,
    validateStatus(status) {
        return status >= 200 && status <= 500;
    },
});



const request = async <T = any>(config: AxiosRequestConfig): Promise<MyResponseType<T>> => {
    try {
        const endpoints = getEndpoints();
        const token = getToken()
        instance.defaults.baseURL = `${endpoints.back}`;

        instance.defaults.headers.common['Appid'] = getAppid()
        if(token){
            instance.defaults.headers.common['Authorization'] = token;
        }
        instance.defaults.headers.common['Accept-Language'] = getLocale()


        const {data} = await instance.request<MyResponseType<T>>(config);
        matchlog.log('api',data)
        if(data.code == 401001){
            localStore.getState().logout()
            throw new Error("Your session has expired, please log in again")
        }
        // if (data.code !== 0) {
        //     throw new Error(data.message);
        // }
        return data;
    } catch (err) {
        console.error('qwe-err', err);
        const message = 'Request Error';
        console.error(message);
        return {
            code: -1,
            data: null as any,
            message,
            success: false,
            fail: true,
            result: null as any,
        };
    }
};

const retryInstance = axios.create({
    timeout: 60000,
    validateStatus(status) {
        return status >= 200 && status <= 500;
    },
});
axiosRetry(retryInstance, {
    retries: 3,
    retryDelay: (retryCount) => retryCount * 1000,
    shouldResetTimeout: true,
    retryCondition: (error) => {
        return (error!.response!.status >= 500 && error!.response!.status<600) || error.code === 'ECONNABORTED';
    },
});
export const retryRequest = async <T = any>(config: AxiosRequestConfig): Promise<MyResponseType<T>> => {
    try {
        const endpoints = getEndpoints();
        const token = getToken()
        retryInstance.defaults.baseURL = `${endpoints.back}`;

        retryInstance.defaults.headers.common['Appid'] = getAppid()
        if(token){
            retryInstance.defaults.headers.common['Authorization'] = token;
        }
        retryInstance.defaults.headers.common['Accept-Language'] = getLocale()


        const {data} = await retryInstance.request<MyResponseType<T>>(config);
        matchlog.log('api',data)
        if(data.code == 401001){
            localStore.getState().logout()
            throw new Error("Your session has expired, please log in again")
        }
        // if (data.code !== 0) {
        //     throw new Error(data.message);
        // }
        return data;
    } catch (err) {
        console.error('qwe-err', err);
        const message = 'Request Error';
        console.error(message);
        return {
            code: -1,
            data: null as any,
            message,
            success: false,
            fail: true,
            result: null as any,
        };
    }
};

export default request;